<template>
  <v-dialog v-model="dialog" max-width="600px">
    <v-card>
      <v-card-title>
        {{ isEdit ? __("Alterar template") : __("Novo template") }}
      </v-card-title>

      <v-card-text>
        <v-form ref="form">
          <v-row>
            <v-col cols="12" md="6">
              <LeadTypeSelect
                v-model="form.lead_type_id"
                :return-object="false"
                :label="__('Tipo')"
                :error="!!errors.lead_type_id"
                :error-messages="errors.lead_type_id"
              />
            </v-col>

            <v-col cols="12" md="6">
              <LeadSubtypeSelect
                ref="subtype"
                v-model="form.subtype_id"
                :leadTypeId="form.lead_type_id"
                :label="__('Subtipo')"
                :error="!!errors.subtype_id"
                :error-messages="errors.subtype_id"
              />
            </v-col>
          </v-row>

          <v-text-field
            v-model="form.name"
            :label="__('Nome')"
            :error="!!errors.name"
            :error-messages="errors.name"
          />

          <v-file-input
            v-model="file"
            :label="__('Arquivo')"
            accept=".docx"
            :error="!!errors.file"
            :error-messages="errors.file"
            chips
            show-size
            :counter="false"
          >
            <template #prepend>
              <span v-if="isEdit && form.file_url">
                Arquivo atual:
                <a :href="form.file_url" target="_blank">
                  {{ extractFileName(form.file_url) }}
                </a>
              </span>
            </template>
          </v-file-input>
        </v-form>
      </v-card-text>

      <v-card-actions class="justify-end">
        <v-btn text @click="close">{{ __("Cancelar") }}</v-btn>
        <v-btn color="primary" @click="submit" :loading="loading">
          {{ __("Salvar") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import * as formTemplatesService from "@/services/forms/form_templates";
import ToastsMixin from "@/mixins/ToastsMixin.vue";
import i18n from "@/mixins/i18n";
import LeadTypeSelect from "@/components/LeadTypes/LeadTypeSelect";
import LeadSubtypeSelect from "@/components/LeadSubtypes/LeadSubtypeSelect.vue";

export default {
  mixins: [i18n, ToastsMixin],

  components: {
    LeadTypeSelect,
    LeadSubtypeSelect,
  },

  data() {
    return {
      i18n_prefix: "form_templates",
      dialog: false,
      loading: false,
      isEdit: false,

      form: {
        id: null,
        name: "",
        lead_type_id: null,
        subtype_id: null,
        file_url: null,
      },

      file: null,
      errors: {},
    };
  },

  methods: {
    async open(item = null) {
      this.reset();
      this.dialog = true;

      if (item) {
        this.isEdit = true;

        this.form.id = item.id;
        this.form.name = item.name;
        this.form.file_url = item.public_url || item.file_url || null;
        this.form.lead_type_id = item.lead_type_id || null;

        await this.$nextTick();

        if (this.form.lead_type_id && this.$refs.subtype) {
          await this.$refs.subtype.handleGetSubtypesByLeadType(
            this.form.lead_type_id
          );
        }

        this.form.subtype_id = item.subtype_id || null;
      }
    },

    close() {
      this.dialog = false;
    },

    reset() {
      this.isEdit = false;
      this.form = {
        id: null,
        name: "",
        lead_type_id: null,
        subtype_id: null,
        file_url: null,
      };
      this.file = null;
      this.errors = {};
    },

    extractFileName(url) {
      return url.split("/").pop();
    },

    async submit() {
      try {
        this.loading = true;

        const formData = new FormData();
        formData.append("lead_type_id", this.form.lead_type_id);
        formData.append("subtype_id", this.form.subtype_id);
        formData.append("name", this.form.name);

        if (this.file) {
          formData.append("file", this.file);
        }

        let response;

        if (this.isEdit) {
          response = await formTemplatesService.update(this.form.id, formData);
        } else {
          response = await formTemplatesService.store(formData);
        }

        this.$emit("submit");
        this.close();

        this.toastSuccess(
          response.data.message ||
            this.__("Operação realizada", "form_templates")
        );
      } catch (e) {
        if (e.response?.data?.errors) {
          this.errors = e.response.data.errors;
        }

        const message =
          e?.response?.data?.message ||
          e?.message ||
          this.__("Erro inesperado", "form_templates");

        this.toastError(message);
      } finally {
        this.loading = false;
      }
    },
  },

  watch: {
    "form.name"() {
      this.errors.name = null;
    },

    "form.lead_type_id"(value, oldValue) {
      this.errors.lead_type_id = null;
      this.errors.subtype_id = null;

      if (value !== oldValue && oldValue !== null) {
        this.form.subtype_id = null;
      }
    },

    "form.subtype_id"() {
      this.errors.subtype_id = null;
    },
  },
};
</script>
